
import Header from "../components/header.jsx";
import AdminSidebar from "../components/adminSidebar.jsx";
import AdminPaidCustomer from "../components/adminPaidCustomer.jsx";
import Footer from "../components/footer.jsx";

function AdminPaidCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <AdminSidebar /> 
      < AdminPaidCustomer/> 
    </div>
    <Footer /> 
  </div>

  );
}
export default AdminPaidCustomerPage;
